import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react/macro";
import { cn } from "@/lib/utils";
import type { HelpCategoryId } from "@/types/help";

interface CategoryMeta {
  label: MessageDescriptor;
  /** Background token for the category pill (text is always white). */
  pillClassName: string;
}

export const CATEGORY_META: Record<HelpCategoryId, CategoryMeta> = {
  "getting-started": {
    label: msg`Getting Started`,
    pillClassName: "bg-(--color-warning)",
  },
  guides: {
    label: msg`Guides`,
    pillClassName: "bg-(--color-status-active)",
  },
  troubleshooting: {
    label: msg`Troubleshooting`,
    pillClassName: "bg-(--color-priority-high)",
  },
  "whats-new": {
    label: msg`What's New`,
    pillClassName: "bg-(--brand-blue)",
  },
};

export const CATEGORY_ORDER: HelpCategoryId[] = [
  "getting-started",
  "guides",
  "troubleshooting",
  "whats-new",
];

export function CategoryPill({
  category,
  className,
}: {
  category: HelpCategoryId;
  className?: string;
}) {
  const { t } = useLingui();
  const meta = CATEGORY_META[category];

  return (
    <span
      className={cn(
        "inline-flex w-fit items-center rounded-full px-3 py-2 text-sm font-medium text-white",
        meta.pillClassName,
        className,
      )}
    >
      {t(meta.label)}
    </span>
  );
}
